<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="name" >
        <el-input v-model="queryParams.name" placeholder="平台名称"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="platformDomain">
        <el-input v-model="queryParams.platformDomain" placeholder="平台域名"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="type" >
        <el-select v-model="queryParams.type" filterable clearable  placeholder="类型" >
          <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click.native="add">新增</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-top: 10px">
        <el-table :data="tableData" border>
          <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="name" label="平台名称" align="center"></el-table-column>
          <el-table-column prop="platformDomain" label="平台域名" align="center"></el-table-column>
          <el-table-column prop="apiDomain" label="api域名" align="center"></el-table-column>
          <el-table-column prop="h5Domain" label="H5域名" align="center"></el-table-column>
          <el-table-column prop="username" label="用户名称" align="center"></el-table-column>
          <el-table-column prop="status" label="类型" :formatter="typeFormat" align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建日期" align="center"></el-table-column>
          <el-table-column label="操作" width="230" align="center">
            <template slot-scope="scope">
							<el-button size="mini" type="primary" plain icon="el-icon-edit" @click="updateRow(scope.row)" >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
  </div>
</template>
<script>
import { platformPage } from "@/api/api.js"; //平台分页列表
export default {
  name:'platformIndex',
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      title:"",
      form:{},
      optPackage: [],
      type: [
        { value: 1, label: "管理员" },
        { value: 2, label: "代理商" }
      ],
    }
  },
  methods: {
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 获取列表的数据
    initData(){
      let params= {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      platformPage(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 编辑
    updateRow(row){
        let type = row.type;
        let userId = row.userId;
        let id = row.id;
        if(type=='2'){
          //代理商
          this.$router.push('/platformSetting/userSetting/' + userId);
        }else{
          this.$router.push('/platformSetting/edit/' + id);
        }
    },
    add(){
      this.$router.push('/platformSetting/add');
    },
    typeFormat(row){
      return row.type=='1' ? '管理员' : '代理商';
    }
  },
  mounted() {
    this.initData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
</style>


